import { Injectable } from '@angular/core';
import { debounceTime } from 'rxjs/operators';
import { Subject } from 'rxjs';

import { Entity } from '@proman/services/entity.service';

@Injectable({ providedIn: 'root' })
export class TemplatesRenderService {
  input: Subject<number> = new Subject();
  value: Subject<string> = new Subject();

  constructor(
    private Entity: Entity,
  ) {
    this.input.pipe(debounceTime(500)).subscribe((value) => {
      this.Entity.get('template').render({ id: value }).then((response) => {
        this.value.next(response);
      });
    });
  }
}
